export const SET_CURRENT_USER_INFO = 'SET_CURRENT_USER_INFO';
export const SET_USER_PREFERENCES = 'SET_USER_PREFERENCES';
export const SET_IS_REQUEST_IN_PROGRESS = 'SET_IS_REQUEST_IN_PROGRESS';
export const SET_ALERTS_LAST_QUERY_TIME = 'SET_ALERTS_LAST_QUERY_TIME';
export const TOGGLE_COMM_CHECKBOX = 'TOGGLE_COMM_CHECKBOX';
export const UPDATE_EXCLUDED_CHECKBOX_ARR = 'INIT_EXCLUDED_CHECKBOX_ARR';
export const UPDATE_ALERTS_STATE_ARR = 'UPDATE_ALERTS_STATE_ARR';
export const UPDATE_VMA_DROPDOWN_OPTIONS = 'UPDATE_VMA_DROPDOWN_OPTIONS';
export const UPDATE_VMA_LIST = 'UPDATE_VMA_LIST';
export const SELECT_CONTROL_UNIT = 'SELECT_CONTROL_UNIT';
export const SELECT_ORGANIZATION_ID = 'SELECT_ORGANIZATION_ID';
export const SET_LAST_CONTROL_UNIT_TIME_INTERVAL = 'SET_LAST_CONTROL_UNIT_TIME_INTERVAL'
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const SET_REMOTE_TABLE_LOADING = 'SET_REMOTE_TABLE_LOADING';
export const SET_IS_PREPARING_EXCEL_DATA = 'SET_IS_PREPARING_EXCEL_DATA';
export const UPDATE_MULTI_SELECT_FILTER = 'UPDATE_MULTI_SELECT_FILTER';
export const INITIALIZE_MULTI_SELECT_FILTERS = 'INITIALIZE_MULTI_SELECT_FILTERS';
export const SET_SORT_CARET_CLASS_NAME = 'SET_CARET_CLASS_NAME';
export const SET_IS_FILTER_ENTER_KEY_PRESSED = 'SET_IS_FILTER_ENTER_KEY_PRESSED';
export const SET_CU_UPDATE_DATE = 'SET_CU_UPDATE_DATE';
export const SET_CU_CURRENT_VERSION = 'SET_CU_CURRENT_VERSION';
export const SET_CU_NEWEST_VERSION = 'SET_CU_NEWEST_VERSION';
export const SET_CU_DETAILS = 'SET_CU_DETAILS';
